module.exports = __webpack_public_path__ + "static/media/they-took-to-the-sky.db185c6c.jpg";